/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import { getLcSubMarcas } from "../../services/LcSubMarcaService";
import { saveLcProducto } from "../../services/LcProductoService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  id: null,
  idLcMarca: null,
  idLcSubmarca: null,
  idLcDiagnostico: null,
  idLcMaterial: null,
  idLcTiempoUso: null,
  idLcTipo: null,
  idLcColor: null,
  multifocal: false,
  disponibleOs: false,
  descripcion: "",
  descripcionCorta: "",
  observaciones: "",
};

const nameItemText = "Producto de Lente de Contacto";
const itemGender = "M";
//
// ########################################################################### 
//
const LcProductoDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [lcMarcas, setLcMarcas] = useState([]);
  const [lcSubMarcas, setLcSubMarcas] = useState([]);
  const [lcDiagnosticos, setLcDiagnosticos] = useState([]);
  const [lcMateriales, setLcMateriales] = useState([]);
  const [lcTiemposUso, setLcTiemposUso] = useState([]);
  const [lcTipos, setLcTipos] = useState([]);
  const [lcColores, setLcColores] = useState([]);
  const [valueACLcMarca, setValueACLcMarca] = useState(itemCrud.lcMarca);
  const [inputValueACLcMarca, setInputValueACLcMarca] = useState("");
  const [valueACLcSubMarca, setValueACLcSubMarca] = useState(itemCrud.lcSubMarca);
  const [inputValueACLcSubMarca, setInputValueACLcSubMarca] = useState("");
  const [valueACLcDiagnostico, setValueACLcDiagnostico] = useState(itemCrud.lcDiagnostico);
  const [inputValueACLcDiagnostico, setInputValueACLcDiagnostico] = useState("");
  const [valueACLcMaterial, setValueACLcMaterial] = useState(itemCrud.lcMaterial);
  const [inputValueACLcMaterial, setInputValueACLcMaterial] = useState("");
  const [valueACLcTiempoUso, setValueACLcTiempoUso] = useState(itemCrud.lcTiempoUso);
  const [inputValueACLcTiempoUso, setInputValueACLcTiempoUso] = useState("");
  const [valueACLcTipo, setValueACLcTipo] = useState(itemCrud.lcTipo);
  const [inputValueACLcTipo, setInputValueACLcTipo] = useState("");
  const [valueACLcColor, setValueACLcColor] = useState(itemCrud.lcColor);
  const [inputValueACLcColor, setInputValueACLcColor] = useState("");
  //
  // ################################################################################
  //
  useEffect(() => {
    loadLcMarcas();
    loadLcDiagnosticos();
    loadLcMateriales();
    loadLcTiemposUso();
    loadLcTipos();
    loadLcColores();

    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (valueACLcMarca) {
      if (itemCrud && itemCrud.lcMarca) {
        if (itemCrud.lcMarca.id !== valueACLcMarca.id || (itemCrud.lcSubMarca !== valueACLcSubMarca)) {
          setValueACLcSubMarca(null);
        }
        loadLcSubMarcas(valueACLcMarca.id);
      } else {
        setValueACLcSubMarca(null);
      }
      loadLcSubMarcas(valueACLcMarca.id);
    }
  }, [valueACLcMarca])
  //
  // ################################################################################
  // 
  useEffect(() => {

    let _lcSubMarca = valueACLcSubMarca ? valueACLcSubMarca.label + " | " : "";
    let _lcColor = valueACLcColor ? valueACLcColor.label + (itemCrudLocal.multifocal ? " | " : "") : "";
    let _multifocal = itemCrudLocal.multifocal ? "MULTIFOCAL" : "";
    let _descripcion = _lcSubMarca + _lcColor + _multifocal;

    setItemCrudLocal((prev) => ({
      ...prev,
      descripcion: _descripcion,
    }));
  }, [valueACLcSubMarca, valueACLcColor, itemCrudLocal.multifocal]);
  //
  // ################################################################################
  //
  const loadLcMarcas = async () => {
    const response = await getCacheData("lc_marca")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcMarcas(_var);
    } else {
      setLcMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcSubMarcas = async (idLcMarca) => {
    const response = await getLcSubMarcas({ idLcMarca: idLcMarca });
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcSubMarcas(_var);
    } else {
      setLcSubMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcDiagnosticos = async () => {
    const response = await getCacheData("lc_diagnostico")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcDiagnosticos(_var);
    } else {
      setLcDiagnosticos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcMateriales = async () => {
    const response = await getCacheData("lc_material")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcMateriales(_var);
    } else {
      setLcMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcTiemposUso = async () => {
    const response = await getCacheData("lc_tiempo_uso")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: String(item.valor),
        });
      });
      setLcTiemposUso(_var);
    } else {
      setLcTiemposUso([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcTipos = async () => {
    const response = await getCacheData("lc_tipo")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcTipos(_var);
    } else {
      setLcTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcColores = async () => {
    const response = await getCacheData("lc_color")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcColores(_var);
    } else {
      setLcColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (valueACLcMarca === null) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar la Marca Producto del Lente de Contacto",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Submarca Producto del Lente de Contacto",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      id_lc_marca: valueACLcMarca.id,
      id_lc_submarca: valueACLcSubMarca.id,
      id_lc_diagnostico: valueACLcDiagnostico.id,
      id_lc_material: valueACLcMaterial.id,
      id_lc_tiempo_uso: valueACLcTiempoUso.id,
      id_lc_tipo: valueACLcTipo.id,
      multifocal: itemCrudLocal.multifocal,
      id_lc_color: valueACLcColor.id,
      descripcion: itemCrudLocal.descripcion,
      descripcion_corta: itemCrudLocal.descripcionCorta,
      observaciones: itemCrudLocal.observaciones ? itemCrudLocal.observaciones.toLocaleUpperCase() : "",
      disponible_obra_social: itemCrudLocal.disponibleOs,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrud.id;
    }

    setIsDoingSomething(true);
    const response = await saveLcProducto(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-marca-producto"
                size="small"
                value={
                  valueACLcMarca && valueACLcMarca.id
                    ? valueACLcMarca
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcMarca(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idLcMarca: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcMarca}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcMarca(newInputValue);
                }}
                options={lcMarcas}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Marca del Producto" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-submarca-producto"
                size="small"
                value={
                  valueACLcSubMarca && valueACLcSubMarca.id
                    ? valueACLcSubMarca
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcSubMarca(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idLcSubMarca: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcSubMarca}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcSubMarca(newInputValue);
                }}
                options={lcSubMarcas}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="SubMarca del Producto" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-diagnostico"
                size="small"
                value={
                  valueACLcDiagnostico && valueACLcDiagnostico.id
                    ? valueACLcDiagnostico
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcDiagnostico(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idLcDiagnostico: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcDiagnostico}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcDiagnostico(newInputValue);
                }}
                options={lcDiagnosticos}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Diagnóstico" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-material"
                size="small"
                value={
                  valueACLcMaterial && valueACLcMaterial.id
                    ? valueACLcMaterial
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcMaterial(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idLcMaterial: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcMaterial}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcMaterial(newInputValue);
                }}
                options={lcMateriales}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Material" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-tiempo-uso"
                size="small"
                value={
                  valueACLcTiempoUso && valueACLcTiempoUso.id
                    ? valueACLcTiempoUso
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcTiempoUso(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idLcTiempoUso: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcTiempoUso}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcTiempoUso(newInputValue);
                }}
                options={lcTiemposUso}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Tiempo de Uso" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-tipo"
                size="small"
                value={
                  valueACLcTipo && valueACLcTipo.id
                    ? valueACLcTipo
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcTipo(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idLcTipo: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcTipo}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcTipo(newInputValue);
                }}
                options={lcTipos}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Tipo" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.multifocal ?? false}
                    onChange={handleChange}
                    name="multifocal"
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Multifocal"
              />
            </Grid>

            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.disponibleOs ?? false}
                    onChange={handleChange}
                    name="disponibleOs"
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Disponible para Obra Social"
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-color"
                size="small"
                value={
                  valueACLcColor && valueACLcColor.id
                    ? valueACLcColor
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACLcColor(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idLcColor: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACLcColor}
                onInputChange={(event, newInputValue) => {
                  setInputValueACLcColor(newInputValue);
                }}
                options={lcColores}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Color" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                // disabled={
                //   actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                // }
                disabled={true}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion_corta"
                label="Descripción Abreviada"
                variant="outlined"
                size="small"
                name="descripcionCorta"
                value={itemCrudLocal.descripcionCorta}
                onChange={handleChange}
                onFocus={() => {
                  if (itemCrudLocal.descripcionCorta === "") {
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      descripcionCorta: itemCrudLocal.descripcion,
                    });
                  }
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default LcProductoDialog;
